export const WEEK_DAYS = [1, 2, 3, 4, 5];
export const WEEKEND_DAYS = [0, 6];
export const WEEK_DAYS_NAMES = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
export const WEEK_DAYS_NAMES_SHORT = ['Ndz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'];

export const weekDays = (dateInWeek: any) => {
	let days = new Array();

	const currentDate = new Date(dateInWeek);

	if (currentDate.getDay() === 0) {
		currentDate.setDate(currentDate.getDate() - 1);
	}

	const first = currentDate.getDate() - currentDate.getDay() + 1;

	if (first > 0) {
		currentDate.setDate(first);
	} else if (first < 0) {
		currentDate.setDate(0);
		currentDate.setDate(currentDate.getDate() - Math.abs(first));
	}

	for (let i = 0; i < 7; i++) {
		const date = new Date(currentDate);
		date.setDate(currentDate.getDate() + i);
		date.setHours(0, 0, 0, 0);
		days.push(dateToString(new Date(date)));
	}

	return days;
};

/**
 * Convert date object to string in format yyyy-mm-dd
 *
 * @param {Date} date
 * @returns {string} date string in format yyyy-mm-dd
 */
export const dateToString = (date: any) => {
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();

	return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
};
